import { useState } from 'react'
import { Typography } from '@material-tailwind/react'
import { useTranslation } from 'react-i18next'
import ArrowAccordionIcon from '../../images/icons/ArrowAccordionIcon'
import { useForm } from 'react-hook-form'
import { getBalancesByService } from '../tableHelpers/tableConfig'
import { useGetContractPeriodQuery } from '../../store/auth/authService'
import { useParams } from 'react-router-dom'
import FilterDateItem from '../tableHelpers/filters/FilterDateItem'
import FilterSearch from '../tableHelpers/filters/FilterSearch'
import FilterItem from '../tableHelpers/filters/FilterItem'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/store'
import { BalancesFilterFormType } from './BalancesPage.types'
import MobileFilters from './mobile/MobileFilters'
import DownloadBtnLarge from '../tableHelpers/buttons/DownloadBtnLarge'
import { hasRoleAccess } from '../../utils/roles'


const BalancesFilters = (props: any) => {

    const { roles, fetchPage, isLoadingFetch, onSearch, downloadExcel, disabledDownload } = props

    const { t } = useTranslation()

    const { param_contract_id } = useParams()
    const { data } = useGetContractPeriodQuery({
        contract_id: param_contract_id,
        endOffset: 3
    })

    const defaultState: BalancesFilterFormType = {
        periodFrom: '',
        periodTo: '',
        balances: [],
    }
    const {
        control,
        reset,
        getValues,
    } = useForm<BalancesFilterFormType>({
        defaultValues: defaultState,
    })

    const service_id = useSelector((state: RootState) => state.contract.service_id)

    const [filtersState, setFiltersState] = useState<BalancesFilterFormType>(defaultState);

    const handleCloseFilter = () => {
        const values = getValues()

        setFiltersState(values)

        if (JSON.stringify(values) !== JSON.stringify(filtersState)) {
            // fetch page with new filters 
            fetchPage(values)
        }
    }
    const handleClearFilter = () => {
        setFiltersState(defaultState)
        reset()
        if (JSON.stringify(defaultState) !== JSON.stringify(filtersState)) {
            // fetch page with new filters 
            fetchPage(defaultState)
        }
    }


    return (
        <>
            <div className='tab:!hidden'>
                <MobileFilters
                    defaultState={defaultState}
                    handleCloseFilters={handleCloseFilter}
                    handleClearFilter={handleClearFilter}
                    control={control}
                    onSearch={onSearch}
                    datesData={data}
                    filtersState={filtersState}
                />
                <DownloadBtnLarge
                    text={t('consumption.download_excel')}
                    handleDownloadFile={downloadExcel}
                    className='justify-center'
                    disabled={disabledDownload}
                />
            </div>
            <div className='
                hidden tab:flex justify-between items-center flex-wrap gap-[4px] tab:gap-[16px]  mb-[24px] lap:mb-[32px]
            '>
                <div className='flex items-center gap-[8px]'>
                    <Typography className='text-gray-700'>
                        {t('filters.period')}
                    </Typography>
                    <FilterDateItem
                        isLoadingFetch={isLoadingFetch}
                        placement={'bottom-start'}
                        control={control}
                        fieldName={'periodFrom'}
                        label={t("filters.period_from")}
                        datesData={data}
                        handleCloseFilter={handleCloseFilter}
                        isDisabled={(date: string) => {
                            return moment(filtersState.periodTo, 'MM-YYYY').isBefore(moment(date, 'MM-YYYY'))
                        }}
                    />
                    <span className='rotate-90'>
                        <ArrowAccordionIcon />
                    </span>
                    <FilterDateItem
                        isLoadingFetch={isLoadingFetch}
                        placement={'bottom-end'}
                        control={control}
                        fieldName={'periodTo'}
                        label={t("filters.period_to")}
                        datesData={data}
                        handleCloseFilter={handleCloseFilter}
                        isDisabled={(date: string) => {
                            return moment(filtersState.periodFrom, 'MM-YYYY').isAfter(moment(date, 'MM-YYYY'))
                        }}
                    />
                </div>
                <div className='flex items-center gap-[4px] ml-auto'>
                    <FilterItem
                        isLoadingFetch={isLoadingFetch}
                        control={control}
                        label={t('filters.balance_type')}
                        fieldName={'balances'}
                        defaultValue={defaultState.balances}
                        filtersData={getBalancesByService(service_id)}
                        handleCloseFilter={handleCloseFilter}
                    />
                    <FilterSearch
                        onSearch={onSearch}
                    />
                    {
                        hasRoleAccess('balances.download', roles) &&
                        <DownloadBtnLarge
                            text={t('consumption.download_excel')}
                            handleDownloadFile={downloadExcel}
                            className='ml-2'
                            disabled={disabledDownload}
                        />
                    }
                </div>
            </div>
        </>
    )
}

export default BalancesFilters
